import React, { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useStateRef from 'react-usestateref'
import useInterval from '@use-it/interval'
import Pusher from 'pusher-js';
import { setWindowConnectionState } from '../websocket_connection.jsx'

export default function PusherConnection({ onMessageCompleted, channels, ...props}) {

  const config = useSelector(state => state.websocket?.pusher)

  if(!config || !config.enabled) {
    console.warn("[PUSHER] disabled")
    return <></>
  }
  
  const [renderedConnectionState, setConnectionState, connectionState] = useStateRef("connecting")


  const [connectionRetries, setConnectionRetries] = useState(0)

  const connectionInitialized = (data) => {
    console.debug("[PUSHER] connectionInitialized", data)
    setConnectionState("initialized")
    setWindowConnectionState("pusher", false)
  }
  const connectionConnecting = (data) => {
    console.debug("[PUSHER] connectionConnecting", data)
    setConnectionState("connecting")
    setWindowConnectionState("pusher", false)
  }
  const connectionConnected = (data) => {
    console.debug("[PUSHER] connectionConnected", data)
    setConnectionState("connected")
    setWindowConnectionState("pusher", true)
  }
  const connectionUnavailable = (data) => {
    console.debug("[PUSHER] connectionUnavailable", data)
    setConnectionState("unavailable")
    setWindowConnectionState("pusher", false)
  }
  const connectionFailed = (data) => {
    console.debug("[PUSHER] connectionFailed", data)
    setConnectionState("failed")
    setWindowConnectionState("pusher", false)
  }
  const connectionDisconnected = (data) => {
    console.debug("[PUSHER] connectionDisconnected", data)
    setConnectionState("disconnected")
    setWindowConnectionState("pusher", false)
  }
  const connectionUnloading = (data) => {
    console.debug("[PUSHER] connectionUnloading", data)
    setConnectionState("unloading")
    setWindowConnectionState("pusher", false)
  }

  useEffect(() => {

    Pusher.log = function(msg) {
      console.debug(msg);
    };
    console.debug({config})
    
    const client = new Pusher(config.app_key, {
        cluster: config.cluster,
        wsHost: config.ws_host,
        wsPort: config.ws_port,
        wsPath: config.ws_path,
        forceTLS: config.force_tls,
        enabledTransports: config.enabled_transports
    })
    client.connection.bind("initialized", connectionInitialized)
    client.connection.bind("connecting", connectionConnecting)
    client.connection.bind("connected", connectionConnected)
    client.connection.bind("unavailable", connectionUnavailable)
    client.connection.bind("failed", connectionFailed)
    client.connection.bind("disconnected", connectionDisconnected)
    client.connection.bind("unloading", connectionUnloading)

    channels.map(channelName => {

      const subscription = client.subscribe(channelName).bind_global((eventName, message) => {
        if(eventName.startsWith("CABLE_")) {
          console.warn("[PUSHER]", eventName)
          console.warn("[PUSHER]", message)
          if (message.data) {
            //const rawData = decode(message.binaryBody)
            console.debug('[PUSHER] got message in channel ' + channelName + ' with body ', message.data);
            //const data = JSON.parse(message.data)
            try {
              onMessageCompleted("pusher", message.id, { type: eventName, payload: message.data })
            } catch(ex) {
              console.error(ex)
            }
          } else {
            console.error('[PUSHER] got empty message');
          }
        } else {
          console.log('[PUSHER] SKIPPING MESSAGE');
        }
      })
    })

    return () => {
      console.warn("Unloading pusher");
      client.disconnect()
    }
  }, [config, channels])




  if(false) {
    return <div style={{fontSize: "0.6rem", padding: "10px", backgroundColor: "white"}}>
      <pre>{JSON.stringify(parseJwt(config.token), null, 3)}</pre>
      <div className="btn btn-danger btn-sm" onClick={() => { 
          //client.publish({ destination: '/exchange/public', body: encode('Hello world') }); 
          client.publish({ destination: '/queue/public', body: encode('Hello world') }); 

        } }>
        Publish
      </div>
    </div>
  }


  switch(connectionState?.current) {
    case "initialized":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Initializing via Pusher... Try #{connectionRetries}
      </div>
    case "connecting":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Connecting via Pusher... Try #{connectionRetries}
      </div>
    case "connected":
      return <div className="network-status network-status-success">
        <i className="fa fa-check"></i>{" "}
        Pusher connected
      </div>
    case "unavailable":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Pusher unavailable
      </div>

    case "failed":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Pusher connection failed
      </div>
    case "disconnected":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Pusher disconnected
      </div>
    case "unloading":
      return <></>
    default:
      return <div className="network-status network-status-danger">Unknown connection state for  Pusher</div>
  }

  return <></>
}
